import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { change, Field, formValueSelector, reduxForm } from "redux-form";
import RenderFieldNormalInput from "../../components/input/renderFieldInput";
import { handleApiErrors } from "../../lib/api-errors";
import { required, validatePhone } from "../../util/validation";

import * as _ from "lodash";
import { makeGetDataAccount } from "../../lib/selector";
import RenderFieldDateTime from "../../components/input/renderFieldDatetime";
import RenderNormalSelect from "../../components/input/renderNormalSelect";
import InputPhoneNumber from "../../components/input/inputPhoneNumber";
import RenderFieldArea from "../../components/input/renderArea";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

function PageAccountDetailOrganization(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [provinceList, setProvinceList] = useState([]);
  const { dataAccount, ocrData, handleSubmit, _handleToast } = props;

  useEffect(() => {
    if (!dataAccount) {
      history.push("/open-account/check-info");
      return;
    }
    // lấy danh sách tỉnh thành
    getProvinceList();
  }, []);

  function submit(values) {
    history.push("/open-account/verify");
    return;
  }

  function getSaleId(id) {
    const url = `${apiUrl}/getSaleId`;

    const param = {
      user: "back",
      cmd: "GET_SALEID",
      sid: dataAccount?.S_ID,
      param: {
        C_SALE_ID: id,
      },
    };

    const request = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(param),
    });

    request
      .then(handleApiErrors)
      .then((response) => response.json())
      .then((json) => {
        if (json.iRs > 0) {
          // chưa có tài khoản
          if (json.data && !!json.data.length) {
            dispatch(
              change(
                "pageAccountDetailO",
                "inputNamePresenter",
                json.data[0].SALE_NAME
              )
            );
          } else {
            _handleToast("Không tìm thấy Sale phù hợp", "warning");
          }
        } else {
          _handleToast(json.sRs, "warning");
        }
      })
      .catch((error) => {
        throw error;
      });
  }

  function getProvinceList() {
    const url = `${apiUrl}/listProvince`;

    const param = {
      user: "back",
      cmd: "LIST_PROVINCE",
      sid: dataAccount?.S_ID,
      param: {},
    };

    const request = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(param),
    });

    request
      .then(handleApiErrors)
      .then((response) => response.json())
      .then((json) => {
        if (json.iRs > 0) {
          // chưa có tài khoản
          if (json.data && !!json.data.length) {
            setProvinceList(json.data);
          } else {
            setProvinceList([]);
            _handleToast("Không tìm thấy danh sách tỉnh thành", "warning");
          }
        } else {
          _handleToast(json.sRs, "warning");
        }
      })
      .catch((error) => {
        throw error;
      });
  }

  function _handleBlurPresenter(e) {
    const { value } = e.target;
    if (value && value.trim()) getSaleId(value.trim());
  }

  return (
    <Container>
      <Row>
        <Col lg="10" className="offset-lg-1">
          <div className="content pt180">
            <h2 className="mt-3">Xác thực thông tin khách hàng</h2>
            <p className="mt-0">Quý khách vui lòng nhập thông tin dưới đây</p>
            <form className="account-form" onSubmit={handleSubmit(submit)}>
              <Form.Group>
                <label htmlFor="inputFname">
                  Tên công ty <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputFname"
                  type="text"
                  className="form-control"
                  placeholder="Nhập tên công ty"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputTaxIdentity">
                  Mã số thuế <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputTaxIdentity"
                  type="text"
                  className="form-control"
                  placeholder="Nhập mã số thuế"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputNoiCap">
                  Nơi cấp <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputNoiCap"
                  component={RenderNormalSelect}
                  className="form-control"
                  validate={required}
                  opts={provinceList}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputPermit">
                  Số CNĐKDN/GPTL <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputPermit"
                  type="text"
                  className="form-control"
                  placeholder="Nhập CNĐKDN/GPTL"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputNgayCap">
                  Ngày cấp <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputNgayCap"
                  type="text"
                  className="form-control"
                  placeholder="Nhập ngày cấp"
                  component={RenderFieldDateTime}
                  maxDate={new Date().getTime()}
                  validate={required}
                />
              </Form.Group>

              <Form.Group>
                <label htmlFor="inputDienThoai">
                  Điện thoại <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputDienThoai"
                  type="text"
                  className="form-control"
                  placeholder="Nhập Số ĐT"
                  component={InputPhoneNumber}
                  validate={[required, validatePhone]}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputEmail">
                  Email <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputEmail"
                  type="text"
                  className="form-control"
                  placeholder="Nhập Email"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputTinhThanh">
                  Tỉnh/Thành phố <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputTinhThanh"
                  component={RenderNormalSelect}
                  className="form-control"
                  validate={required}
                  opts={provinceList}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputDiaChi">
                  Địa chỉ liên hệ <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputDiaChi"
                  className="form-control"
                  placeholder="Nhập địa chỉ liên hệ"
                  component={RenderFieldArea}
                  // validate={required}
                  rows="2"
                />
              </Form.Group>
              <hr style={{ gridColumn: "1/4" }} />
              <Form.Group>
                <label htmlFor="inputIDPresenter">
                  ID người giới thiệu <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputIDPresenter"
                  type="text"
                  className="form-control"
                  placeholder="ID người giới thiệu"
                  component={RenderFieldNormalInput}
                  onBlur={_handleBlurPresenter}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputNamePresenter">
                  Họ tên người giới thiệu
                </label>
                <Field
                  name="inputNamePresenter"
                  type="text"
                  className="form-control"
                  placeholder="Họ tên"
                  component={RenderFieldNormalInput}
                  disabled
                />
              </Form.Group>
              <span />
              <Form.Group>
                <label htmlFor="inputRepresentative">
                  Người đại diện <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputRepresentative"
                  type="text"
                  className="form-control"
                  placeholder="Người đại diện"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputPosition">
                  Chức vụ <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputPosition"
                  type="text"
                  className="form-control"
                  placeholder="Chức vụ người đại diện"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>
              <span />
              <Form.Group>
                <label htmlFor="inputCCCD">
                  CMND/CCCD <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputCCCD"
                  type="text"
                  className="form-control"
                  placeholder="Nhập CMND/CCCD"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputCardId">
                  Ngày cấp <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputNgayCapCMT"
                  type="text"
                  className="form-control"
                  placeholder="Ngày cấp"
                  component={RenderFieldDateTime}
                  maxDate={new Date().getTime()}
                  validate={required}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputNoiCapCMT">
                  Nơi cấp <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputNoiCapCMT"
                  type="text"
                  className="form-control"
                  placeholder="Nơi cấp"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>

              <Row
                className="justify-content-center mt-2 mb-5"
                style={{ gridColumn: "1/4" }}
              >
                <Button onClick={() => history.goBack()} className="prev-page">
                  Quay lại
                </Button>
                <Button className="btn-next" type="submit">
                  TIẾP TỤC
                </Button>
              </Row>
            </form>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

PageAccountDetailOrganization = reduxForm({
  form: "pageAccountDetailO",
  enableReinitialize: true,
})(PageAccountDetailOrganization);

const selector = formValueSelector("pageAccountDetailO");

const mapStateToProps = (state) => {
  const getDataAccount = makeGetDataAccount();

  const {
    inputFname,
    inputTaxIdentity,
    inputPermit,
    inputNgayCap,
    inputNoiCap,
    inputDienThoai,
    inputEmail,
    inputTinhThanh,
    inputDiaChi,
    inputIDPresenter,
    inputNamePresenter,
    inputRepresentative,
    inputPosition,
    inputCCCD,
    inputNgayCapCMT,
    inputNoiCapCMT,
  } = selector(
    state,
    "inputFname",
    "inputTaxIdentity",
    "inputPermit",
    "inputNgayCap",
    "inputNoiCap",
    "inputDienThoai",
    "inputEmail",
    "inputTinhThanh",
    "inputDiaChi",
    "inputIDPresenter",
    "inputNamePresenter",
    "inputRepresentative",
    "inputPosition",
    "inputCCCD",
    "inputNgayCapCMT",
    "inputNoiCapCMT"
  );

  return {
    dataAccount: getDataAccount(state),
    inputFname,
    inputTaxIdentity,
    inputPermit,
    inputNgayCap,
    inputNoiCap,
    inputDienThoai,
    inputEmail,
    inputTinhThanh,
    inputDiaChi,
    inputIDPresenter,
    inputNamePresenter,
    inputRepresentative,
    inputPosition,
    inputCCCD,
    inputNgayCapCMT,
    inputNoiCapCMT,
    initialValues: {
      inputFname: "",
      inputTaxIdentity: "",
      inputPermit: "",
      inputNgayCap: "",
      inputNoiCap: "",
      inputDienThoai: "",
      inputEmail: "",
      inputTinhThanh: "",
      inputDiaChi: "",
      inputIDPresenter: "",
      inputNamePresenter: "",
      inputRepresentative: "",
      inputPosition: "",
      inputCCCD: "",
      inputNgayCapCMT: "",
      inputNoiCapCMT: "",
    },
  };
};

export default connect(mapStateToProps)(PageAccountDetailOrganization);
